import React  from 'react';
import { List} from 'antd';
import 'antd/dist/antd.css';
import {FolderOutlined,RightOutlined,PlaySquareOutlined} from '@ant-design/icons'
import {useParams} from 'react-router'
import axios from 'axios'


const getVideoUrl = (name,cb)=>{
  const url = 'http://120.78.175.236:9301/managerServer/ali/getOssFile'
  axios.post(url,{
    fileName:name,
    bucket:0
  }).then(res=>{
    if(res.data.code === 200)
    {
      cb&&cb(false,res)
    }  
  },err=>{
    cb&&cb(true)
    console.log(err)
  })
}
export default props =>{
      const params = useParams()
      const [data,setData]= React.useState([])
      const decodePrefix = decodeURI(params?.prefix || 'learn')
      const [prefix,setPrefix] = React.useState(decodePrefix.replace('_','/')+'/')
      React.useEffect(()=>{
          const _url = 'http://120.78.175.236:9301/managerServer/ali/ossDirectory'
          let data = new FormData()
          data.append('prefix',prefix)
          setLoading(true)
          axios.post(_url,data).then(res=>{
            if(res.data.code === 200)
            {
       
              const dirs = res.data.directorys.map(item=>{
                return {type:'dir',name:item}
              })
              const files = res.data.files.map(item=>{
                return {type:'file',name:item}
              })
              const _data = [...dirs,...files]
              setData(_data)
              setLoading(false)
            }  
          },err=>{
            console.log(err)
            setLoading(false)
          })
      },[prefix])
      //https://fish.oss-test-public.laojiang.work/2022/03/03/sYeD2022514925/1646292413486VID_20210514_100812.mp4
      //'http://fish.oss-pro-public.diaoyu88888.com/learn/01-钓王教你钓大鱼/钓鱼—10.rmvb'
      React.useEffect(()=>{
      document.title = prefix
      },[])
      const [videoUrl,setVideoUrl] = React.useState('')
      const [isFolder,setIsFolder] = React.useState(true)
      const [loading,setLoading] = React.useState(true)
      const [reload,setReload] = React.useState(false)
      return  <>
            {!isFolder ? <video  width="100%" height="280px" controls='controls' >
              <source src={videoUrl}></source>
            </video>:<></>}
            <List 
                bordered
                itemLayout="horizontal"
                dataSource={data}
                loading={loading}
                renderItem={item=>{
                    return <List.Item onClick={()=>{
                                if(item.type === 'dir')
                                {
                                  window.location.href = window.location.href +'/' + encodeURI(item.name.replace('/','_'))
                                }
                                else{
                                  setIsFolder(true)
                                  getVideoUrl(item.name,(err,res)=>{
                                    if(err){
                                      setIsFolder(false)
                                    }
                                    else{
                                      if(res.data.code === 200)
                                      {
                                     
                                        setVideoUrl(res.data.imgUrl)
                                        setIsFolder(false)
                                      }
                                    }
                                  
                                  })
                                }
                            }}>
                              <div>
                              { item.type === 'file'  ? <PlaySquareOutlined />:<FolderOutlined />}
                              {`      ${item.name.replace(prefix,'')}`} 
                              </div>
                              <div>
                              <RightOutlined />
                              </div>
                            </List.Item>
                  }
                }/>
           </>
}